// @flow
import moment from 'moment'

// Types
export type TimePeriod = {
  m?: moment,
  yDiff?: number,
  mDiff?: number,
  dDiff?: number,
  hourDiff?: number,
  minDiff?: number,
  secDiff?: number,
}

// Constants
const CUSTOM_FORMATTERS = {
  en: (x, woPrefix, key) => {
    const data = {
      ss: 'second',
      mm: 'minute',
      hh: 'hour',
      dd: 'day',
      MM: 'month',
      yy: 'year',
    }
    return `${x} ${data[key]}${Math.abs(x) !== 1 ? 's' : ''}`
  },
  es: (x, woPrefix, key) => {
    const data = {
      ss: ['segundo', 'segundos'],
      mm: ['minuto', 'minutos'],
      hh: ['hora', 'horas'],
      dd: ['día', 'días'],
      MM: ['mes', 'meses'],
      yy: ['año', 'años'],
    }
    return `${x} ${data[key][Math.abs(x) !== 1 ? 1 : 0]}`
  },
}

// Utils
function getFormatter(m: ?moment): Function {
  const refMoment = m || moment()
  const lang = refMoment._locale._abbr // eslint-disable-line no-underscore-dangle

  return (
    CUSTOM_FORMATTERS[lang] ||
    // eslint-disable-next-line no-underscore-dangle
    refMoment._locale.relativeTime.bind(refMoment._locale)
  )
}

/**
 * Function that creates a string that represents time perido
 * represented by given object
 * @param  {TimePeriod} period
 * @return {String}
 */
function getTimeString({
  m,
  yDiff,
  mDiff,
  dDiff,
  hourDiff,
  minDiff,
}: TimePeriod) {
  const result = []
  const relativeTime = getFormatter(m)

  if (yDiff) {
    result.push(relativeTime(yDiff, true, 'yy'))
  }
  if (mDiff) {
    result.push(relativeTime(mDiff, true, 'MM'))
  }
  if (dDiff) {
    result.push(relativeTime(dDiff, true, 'dd'))
  }
  if (hourDiff) {
    result.push(relativeTime(hourDiff, true, 'hh'))
  }
  if (minDiff) {
    result.push(relativeTime(minDiff, true, 'mm'))
  }

  // TODO: Our current version of moment in `mozio-web` do not have `ss` formatter
  //       but the latest version have it. So the seconds formatter disabled till
  //       we upgrade moment in mozio-web to the latest version
  // if (secDiff) {
  //   result.push(relativeTime(secDiff, true, 'ss'));
  // }

  return result.join(' ')
}

export default getTimeString
